"use strict";
// @ts-ignore
try {
    self['workbox:window:7.3.0'] && _();
}
catch (e) { }
